import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { prefetchArticleBySlug } from '../../lib/publicContentCache';
import type { ArticleRow } from '../../../../shared/schemas/article';

interface RecentChangelogsSidebarProps {
  entries: ArticleRow[];
  currentSlug: string;
}

export function RecentChangelogsSidebar({ entries, currentSlug }: RecentChangelogsSidebarProps) {
  const others = entries.filter((e) => e.slug !== currentSlug);

  return (
    <aside className="flex w-article-sidebar flex-col gap-6">
      <p className="text-caption-lg text-text-tertiary">Recent Updates</p>

      {others.map((entry) => (
        <a
          key={entry.slug}
          href={`/changelog/${entry.slug}`}
          className="text-btn leading-normal text-text-primary transition-colors hover:text-text-secondary"
          onMouseEnter={() => prefetchArticleBySlug(entry.slug)}
          onFocus={() => prefetchArticleBySlug(entry.slug)}
        >
          {entry.title}
        </a>
      ))}

      <a href="/changelog" className="site-btn-secondary site-btn-md">
        All updates
        <ArrowUpRight size={14} />
      </a>
    </aside>
  );
}
